import { useEffect } from 'react';

const BRAND = 'Stratforth';

/**
 * Sets the document (browser tab) title for the current page and restores the
 * previous title on unmount. Produces "<Page> · Stratforth" for consistency.
 */
export const useDocumentTitle = (title?: string) => {
  useEffect(() => {
    const previous = document.title;
    document.title = title ? `${title} · ${BRAND}` : `${BRAND} Platform`;
    return () => {
      document.title = previous;
    };
  }, [title]);
};
